module.exports = __webpack_public_path__ + "img/PXL_20230526_112216880.7db723c8.jpg";